import React from 'react'
import styled from 'styled-components'
import LightYoutube from './LightYoutube'

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;

  & iframe {
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

function EmbeddedYouTubeVideo({ youTubeLink }) {
  const match =
    /^.*(?:youtu\.be\/|v\/|\/u\/\w\/|embed\/|watch\?v=|shorts\/)([^#&?]*).*/.exec(youTubeLink)
  const youTubeId = match && match[1] && match[1].length === 11 ? match[1] : null

  return (
    <VideoWrapper>
      <LightYoutube youTubeId={youTubeId} />
    </VideoWrapper>
  )
}

export default EmbeddedYouTubeVideo
